import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import echarts from 'echarts';
import preventReClick from '@/assets/preventReClick' // 防多次点击，重复提交
// import axios from 'axios';

import YcyPlayer from '@/components/YcyPlayer';

import {
  Image,
  Button,
  Row,
  Col,
  Tabs,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Radio,
  Select,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  RadioGroup,
  // RadioButton,
  Checkbox,
  // CheckboxButton,
  CheckboxGroup,
  Progress,
  Upload,
  Form,
  FormItem,
  Input,
  InputNumber,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Avatar,
  MessageBox,
  Message,
  Collapse,
  CollapseItem,
  DatePicker,
  Loading,
  Notification,
  container,
  main,
  Card,
  aside,
  Alert,
  Tooltip
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
// Vue.prototype.$http = axios;
Vue.prototype.$echarts = echarts;

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component('YcyPlayer', YcyPlayer)
Vue.use(Image);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Radio);
Vue.use(RadioGroup);
// Vue.use(RadioButton);
Vue.use(Checkbox);
// Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Progress);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Upload);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Avatar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(container);
Vue.use(main);
Vue.use(Card);
Vue.use(aside);
Vue.use(Alert);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Loading.directive);
Vue.use(preventReClick);

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;

// console.log(process.env.VUE_APP_BASEURL,'VUE_APP_BASEURL');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

